import { ArrowLeft, Xmark } from '@peacecover/icon';
import { cva } from 'class-variance-authority';
import type { ReactNode } from 'react';

const topNavigationVariants = cva('w-full flex items-center px-[16px] h-[44px]', {
  variants: {},
  defaultVariants: {}
});

interface TopNavigationProps {
  type?: 'back' | 'close';
  onBackClick?: () => void;
  onCloseClick?: () => void;
  leftComponent?: ReactNode;
  centerComponent?: ReactNode;
  rightComponent?: ReactNode;
  className?: string;
}

export default function TopNavigation({
  type,
  onBackClick,
  onCloseClick,
  leftComponent,
  centerComponent,
  rightComponent,
  className
}: TopNavigationProps) {
  const renderLeftContent = () => {
    if (leftComponent) {
      return leftComponent;
    }

    switch (type) {
      case 'back':
        return (
          <button
            type="button"
            onClick={onBackClick}
            className="flex items-center justify-center w-[44px] h-[44px]"
          >
            <ArrowLeft size={24} />
          </button>
        );

      case 'close':
        return (
          <button
            type="button"
            onClick={onCloseClick}
            className="flex items-center justify-center w-[44px] h-[44px]"
          >
            <Xmark size={24} />
          </button>
        );
      default:
        return <div className="w-[44px] h-[44px]" />;
    }
  };

  const renderRightContent = () => {
    if (rightComponent) {
      return rightComponent;
    }

    return <div className="w-[44px] h-[44px]" />;
  };

  return (
    <div className={topNavigationVariants({ className })}>
      {renderLeftContent()}
      <div className="flex-1 flex items-center justify-center">{centerComponent}</div>
      {renderRightContent()}
    </div>
  );
}
